export enum statusType {
	success = 1,
	edit = 2,
	warning = 3,
	none = 4
};


export let commonHeader = ['Create Question', 'Options', 'Answer', 'Map Syllabus', 'Solution', 'Add Tags'];
export let paragraphHeader = ['Create Scenario'];

// createQuestion
export enum indexOfCommonSection { 'questionContent', 'optionsContent', 'correctAnswer', 'subjects', 'solutionContent', 'tags' };

export enum matrixSection { 'questionContent', 'matrixOptionContent', 'correctAnswer', 'subjects', 'solutionContent', 'tags' };

export enum paragraphSection { 'passageQuestion', 'tags' }
export const indexOfParagraphInSection = ['questionContent', 'optionsContent', 'correctAnswer','stepWiseSolution', 'subjects', 'addDifficultyAndSkills', 'addBenchmarking'];
export const indexOfParagraphInSectionMatrix = ['questionContent', 'matrixOptionContent', 'correctAnswer', 'questionHints','stepWiseSolution', 'subjects'];

export const paragraphInnerHeader = ['Create Question', 'Options', 'Answer', 'Solution', 'Map Syllabus', 'Add Difficulty & Skills', 'Add Benchmarking'];

export const indexOfParagraphInSectionInteger = ['questionContent', 'correctAnswer','stepWiseSolution', 'subjects', 'addDifficultyAndSkills', 'addBenchmarking'];
export const paragraphInnerHeaderInteger = ['Create Question', 'Answer','Solution', 'Map Syllabus', 'Add Difficulty & Skills', 'Add Benchmarking'];


export enum integerSection { 'questionContent', 'correctAnswer', 'subjects', 'solutionContent', 'tags' };
export const integerHeader = ['Create Question', 'Answer', 'Map Syllabus', 'Solution', 'Add Tags']

export enum descriptiveSection { 'questionContent', 'correctAnswer', 'subjects', 'solutionContent', 'tags' };
export const descriptiveSectionKeys = [ 'questionContent', 'subjects', 'stepWiseSolution', 'addDifficultyAndSkills', 'addBenchmarking'];
export const descriptiveHeader = ['Create Question', 'Answer', 'Map Syllabus', 'Solution', 'Add Tags', 'Add Difficulty & Skills', 'Add Benchmarking'];

export const descriptiveHeaderSideTitles = ['Create Question', 'Map Syllabus', 'Hints', 'Solution']
//Study material
export const notesMaterial = [{ key: 'createNotes', title: 'Create Notes' }, { key: 'conceptAndChapter', title: 'Add Concept and Chapters' }, { title: 'Add Tags', key: 'tags' }];
export const videoDetailsMaterial = [{ key: 'videoDetails', title: 'Upload Video' }, { key: 'addVideoDetails', title: 'Add Details' },{ key: 'videoConceptAndChapter', title: 'Add Concept and Chapters' }, { title: 'Add Tags', key: 'videoTags' }];
export const audioDetailsMaterial = [{ key: 'audioDetails', title: 'Upload Audio' }, { key: 'addaudioDetails', title: 'Add Details' },{ key: 'audioConceptAndChapter', title: 'Add Concept and Chapters' }, { title: 'Add Tags', key: 'audioTags' }];
export const formulaMaterial = [{ key: 'formula', title: 'Formula' }, { key: 'subjects', title: 'Map Syllabus' }, { title: 'Add Tags', key: 'tags' }];
export const sampleProblem = [{ key: 'sampleProblem', title: 'Sample Problem' }, { key: 'subjects', title: 'Map Syllabus' }, { title: 'Add Tags', key: 'tags' }];


//Test Papers
export const testPaper = [{ key: 'basicInfo', title: 'Basic Info' },{ key: 'subjects', title: 'Add Test Syllabus' }, { key: 'testFormat', title: 'Test Format' }, { title: 'Test Questions', key: 'testQuestions' }];



export interface contentSection {
	title: string,
	key: string,
	state: statusType,
	visible?: boolean,
	previousState?: statusType,
}

export interface ContentInSection {
	title?: string,
	key?: string,
	previousState?: statusType,
	state?: statusType,
	subType?: contentSection[],
	visible?: boolean
	typeOfQuestion?: string
}

